module.exports = __webpack_public_path__ + "img/meeting-thumbnail-26022025.b1fc0ae4.png";